import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { MediumText } from "../typography";
import { boxShadow } from "../components-style";

import verticalLogoDark from "../../assets/images/logo-vertical-dark.svg";
import verticalLogoLight from "../../assets/images/logo-vertical-light.svg";
import logoLight from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.svg";
import openCloseDarkIcon from "../../assets/images/icons/dark/open-close-icon.svg";
import openCloseLightIcon from "../../assets/images/icons/light/open-close-icon.svg";
import helpIcon from '../../assets/images/icons/circle-help-icon.svg';

import { useLocation, useNavigate } from "react-router-dom";
import { panelItems } from "../../assets/utils/data/panel-items";
import breakpoints from "../../assets/styles/breakpoint";
import { ThemeType, ThemeTypeEnum } from "../../assets/utils/validation/types";
import CustomToast from "./custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import toast from "react-hot-toast";

const Panel: React.FC<{
  isCollapsed: boolean;
  theme: ThemeType;
  setIsCollapsed: () => void;
}> = ({ isCollapsed, theme = ThemeTypeEnum.DEFAULT, setIsCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <PanelDiv
      $isCollapsed={isCollapsed}
      $theme={theme}
      className="d-flex flex-column align-items-center justify-content-between"
    >
      <img
        className="logo"
        src={
          isCollapsed
            ? theme === ThemeTypeEnum.LIGHT
              ? logoLight
              : logoDark
            : theme === ThemeTypeEnum.LIGHT
              ? verticalLogoLight
              : verticalLogoDark
        }
        alt="vertical-logo"
      />
      <PanelItems>
        {panelItems.map((item) => {
          const isActive =
            (item.id === "settings" && (location.pathname.includes("settings/basket") || location.pathname.includes("structure"))) ? true : (location.pathname.includes("basket") || location.pathname.includes("structure")) ? false : (item.id === "data-panel" && location.pathname === "/main"
              ? true : (item.id === "finance" && location.pathname.includes(item.id)) ? true : (item.id === "settings" && location.pathname.includes(item.id)) ? true
                : location.pathname.includes(`${item.id.toLowerCase()}`));
          return (
            <PanelItem
              className={isActive ? "active" : ""}
              key={item.id}
              onClick={() =>
                navigate(
                  item.id.toLowerCase() === "data-panel"
                    ? "/main"
                    : item.id.toLowerCase() === "finance"
                      ? "/finance"
                      : `/${item.id.toLowerCase()}${item.id.toLowerCase() === "settings" ? "" : "/main"
                      }`
                )
              }
            >
              <img
                src={
                  theme === (ThemeTypeEnum.DARK as string) && isActive
                    ? item.icons[1]
                    : theme === (ThemeTypeEnum.DARK as string)
                      ? item.icons[0]
                      : theme === (ThemeTypeEnum.LIGHT as string) && isActive
                        ? item.icons[0]
                        : item.icons[1]
                }
                alt={`${item.id}-item`}
              />
              {!isCollapsed && (
                <MediumText style={{ paddingTop: "2px" }}>{item.name}</MediumText>
              )}
            </PanelItem>
          );
        })}
      </PanelItems>
      <PanelItems><PanelItem onClick={() => toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.INFO}
          text={"На даний момент, інструкція для користувача відстуня.\nУ разі питань звертайтесь на пошту irynamertsalova@gmail.com"}
        />
      ), { duration: 10000 })}>
        <img
          src={helpIcon}
          alt="help-icon"
        />
        {!isCollapsed && <MediumText>Допомога</MediumText>}</PanelItem>
        <PanelItem onClick={setIsCollapsed} data-type="open-close-item">
          <img
            src={
              theme === (ThemeTypeEnum.DARK as string)
                ? openCloseLightIcon
                : openCloseDarkIcon
            }
            alt="open-close-icon"
          />
          {!isCollapsed && <MediumText>Закрити панель</MediumText>}</PanelItem>
      </PanelItems>
    </PanelDiv>
  );
};

export default Panel;

const PanelItems = styled.div`
  width: 100%;
`;

const PanelItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  p {
    transition: display 0.5s ease;
  }

  &[data-type="open-close-item"] {
    display: flex;
    transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1) !important;

    &:hover {
      transform: scale(1.05);
    }
  }
`;

const PanelDiv = styled.div<{
  $isCollapsed: boolean;
  $theme: ThemeType;
}>`
  height: 100vh;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "4rem" : "15rem")};
  transition: width 0.3s ease;
  background-color: ${({ $theme }) =>
    $theme === ThemeTypeEnum.DARK ? COLORS.secondary1 : COLORS.blue};
  position: fixed;
  left: 0;
  top: 0;
  padding: 30px 0;

  .logo {
    height: ${({ $isCollapsed }) => ($isCollapsed ? "60px" : "100px")};
  }

  ${PanelItem} {
    padding: 12px ${({ $isCollapsed }) => ($isCollapsed ? "20px" : "24px")};
    transition: size 0.3s ease;
    gap: ${({ $isCollapsed }) => ($isCollapsed ? "0px" : "18px")};
    justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "start"};

    img {
      width: 24px;
      height: 24px;
      transition: width 0.3s ease;
    }
    p {
      color: ${({ $theme }) =>
    $theme === ThemeTypeEnum.DARK ? COLORS.blue : COLORS.secondary1};
    }

    &.active {
      background-color: ${({ $theme }) =>
    $theme === ThemeTypeEnum.DARK ? COLORS.blue : COLORS.secondary1};
      ${boxShadow("rgba(0, 0, 0, 0.7)")}

      p {
        color: ${({ $theme }) =>
    $theme === ThemeTypeEnum.DARK ? COLORS.secondary1 : COLORS.blue};
      }
    }
  }

  @media (max-height: 630px) {
    padding: 16px 0;
    .logo {
      height: ${({ $isCollapsed }) => ($isCollapsed ? "60px" : "80px")};
    }

    ${PanelItem} {
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }

  @media (max-width: 1024px) {
    z-index: 9999;
  }

  ${breakpoints.md} {
    width: ${({ $isCollapsed }) => ($isCollapsed ? "4rem" : "15rem")};

    .logo {
      /* height: ${({ $isCollapsed }) =>
    $isCollapsed ? "4rem" : "16.5rem"}60px; */
      /* width: 60px; */
    }

    ${PanelItem} {
      padding: 12px ${({ $isCollapsed }) => ($isCollapsed ? "16px" : "20px")};
      transition: size 0.3s ease;
      img {
        width: ${({ $isCollapsed }) => ($isCollapsed ? "22px" : "24px")};
        height: ${({ $isCollapsed }) => ($isCollapsed ? "22px" : "24px")};
        transition: width 0.3s ease;
      }
    }
  }

  ${breakpoints.xs} {
    width: ${({ $isCollapsed }) => ($isCollapsed ? "4rem" : "14rem")};
  }
`;
